import styled, { css } from 'styled-components';

import { colors, monokaiBackground, monokaiBackgroundOffset } from 'global/colors';

export const CourseNameContainer = styled.div`
  background: ${(props) => (props.isDarkMode ? monokaiBackgroundOffset : colors.fsLightBlue)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  a {
    color: ${(props) => (props.isDarkMode ? colors.green : colors.darkBlue2)};
  }

  :hover {
    color: ${(props) => (props.isDarkMode ? colors.white : colors.darkBlue)};
    background: ${(props) => (props.isDarkMode ? monokaiBackground : colors.fsLightBlueHover)};
    a {
      color: ${(props) => (props.isDarkMode ? colors.white : colors.darkBlue)};
      text-decoration: none;
    }
  }
`;

export const CourseName = styled.h5`
  padding: 10px;
  margin-bottom: 0px;
`;

export const Icon = styled.i.attrs(({ icon }) => ({
  className: icon,
}))`
  margin: ${(props) => props.margin || '0px'};
  padding: ${(props) => props.padding || '0px'};
`;

export const RedirectIcon = styled.a.attrs({ className: 'fa fa-external-link' })`
  margin-left: 10px;
`;

export const CourseLessonsContainer = styled.div``;

export const LessonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  :hover {
    color: ${(props) => (props.isDarkMode ? colors.white : colors.darkBlue)};
    background: ${(props) => (props.isDarkMode ? monokaiBackgroundOffset : colors.fsLightBlueHover)};
  }
`;

export const LessonName = styled.h6`
  padding: 10px 0 0 30px;
`;

export const ModuleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start !important;
  align-items: center;
  cursor: pointer;
  padding: 5px;
  padding-left: 60px;
  font-size: 14px;

  :hover {
    color: ${(props) => (props.isDarkMode ? colors.white : colors.darkBlue)};
    background: ${(props) => (props.isDarkMode ? monokaiBackgroundOffset : colors.fsLightBlueHover)};
  }

  ${({ active }) =>
    active &&
    css`
      color: ${(props) => (props.isDarkMode ? colors.white : colors.darkBlue)};
      background: ${(props) => (props.isDarkMode ? monokaiBackgroundOffset : colors.fsLightBlueHover)};
    `}
`;

export const Container = styled.div`
  overflow-y: auto;
  height: 100%;
  ${({ isDarkMode }) =>
    isDarkMode &&
    css`
      color: ${isDarkMode ? colors.green : colors.darkBlue2};
    `};
`;
